import React from 'react';

export const AuthAppContext = React.createContext<{
  appApiUrl?: string;
}>(Object.assign({}));
